import * as React from "react";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
} from "@reach/accordion";
import { css } from "@nju/css";
import { useMaintenance } from "@nju/data-access-portal-technical";
import { Footer } from "@nju/feature-portal-footer";
import { Logo } from "@nju/feature-portal-header";
import { salesRoutes } from "@nju/routes";
import { BlockContent, Box, Heading, Markdown } from "@nju/ui";

export default function MaintenanceModePage() {
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const maintenance = useMaintenance();

  const collapse = React.useCallback(() => {
    setIsCollapsed(!isCollapsed);
  }, [isCollapsed]);

  return (
    <Box className={styles.wrapper()} display="flex" flexDirection="column">
      <BlockContent spacing="m">
        <Logo href={salesRoutes.index.get()} />
      </BlockContent>
      <Box align="end" className={styles.content()} display="flex">
        <BlockContent>
          <Box
            align="center"
            display="flex"
            flexDirection={{
              "@onlyMobile": "column",
            }}
            justify={{
              "@fromTablet": "spaceBetween",
            }}
          >
            <Box
              className={styles.textWrapper()}
              display="flex"
              flexDirection="column"
            >
              <Heading
                className={styles.heading()}
                tone="secondary"
                variant="h1"
              >
                trwają prace serwisowe
              </Heading>
              {maintenance.messageSellersNWT?.title && (
                <>
                  <p className={styles.paragraph()}>
                    {maintenance.messageSellersNWT.title}
                  </p>
                  {maintenance.messageSellersNWT?.body && (
                    <Accordion collapsible={true} onChange={collapse}>
                      <AccordionItem>
                        <AccordionPanel className={styles.accordionPanel()}>
                          <Markdown
                            className="prose"
                            content={maintenance.messageSellersNWT.body}
                          />
                        </AccordionPanel>
                        <AccordionButton className={styles.trigger()}>
                          <Box>{isCollapsed ? "zwiń" : "rozwiń"}</Box>
                        </AccordionButton>
                      </AccordionItem>
                    </Accordion>
                  )}
                </>
              )}
            </Box>
            <div className={styles.imgWrapper()}>
              <img alt="cogs" src="/images/cogs.svg" />
            </div>
          </Box>
        </BlockContent>
      </Box>
      <Footer />
    </Box>
  );
}

const styles = {
  trigger: css({
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    color: "$white",
    mb: "$20",
  }),
  textWrapper: css({
    flex: "1",
  }),
  wrapper: css({
    minHeight: "100vh",
    background:
      "linear-gradient(50deg, $cerulean 0%, $cerulean 60%, $brightCerulean 60%, $brightCerulean 100%)",
  }),
  imgWrapper: css({
    flex: "1",
    display: "flex",
    alignSelf: "flex-end",
    img: {
      maxWidth: "100%",
      "@onlyMobile": {
        mt: "$30",
        maxHeight: "250px",
      },
    },
  }),
  heading: css({
    lineHeight: "1.3",
    "@onlyMobile": {
      fontSize: "20px",
      mb: "$15",
    },
  }),
  text: css({
    color: "$white",
    fontSize: "32px",
    lineHeight: "1.4",
    "@onlyMobile": {
      fontSize: "20px",
    },
  }),
  content: css({
    flex: "1",
  }),
  paragraph: css({
    fontSize: "24px",
    color: "$white",
    mt: "$15",
  }),
  accordionPanel: css({
    color: "$white",
    mt: "$15",
  }),
};
